import styled from '@emotion/styled';
import type { Challenge } from '@/types/challenge';

interface ChallengeDetailViewProps {
  challenge: Challenge;
  children?: React.ReactNode;
}

export function ChallengeDetailView({
  challenge,
  children,
}: ChallengeDetailViewProps) {
  return (
    <Container>
      <Header>
        <TitleGroup>
          <Title>{challenge.name}</Title>
          <GenerationBadge>{challenge.generation}기</GenerationBadge>
        </TitleGroup>
      </Header>

      <InfoGrid>
        <InfoRow>
          <InfoLabel>기간</InfoLabel>
          <InfoValue>
            {challenge.startDate} ~ {challenge.endDate}
          </InfoValue>
        </InfoRow>
        {typeof challenge.totalDays === 'number' && (
          <InfoRow>
            <InfoLabel>평일 수</InfoLabel>
            <InfoValue>{challenge.totalDays}일</InfoValue>
          </InfoRow>
        )}
      </InfoGrid>

      {children}
    </Container>
  );
}

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: ${({ theme }) => theme.spacing.xl};
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  box-shadow: ${({ theme }) => theme.shadows.sm};

  background-color: ${({ theme }) => theme.colors.white};
`;

const Header = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.xl};
  padding-bottom: ${({ theme }) => theme.spacing.lg};
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray200};

  display: flex;
  align-items: center;
`;

const TitleGroup = styled.div`
  display: inline-flex;
  gap: ${({ theme }) => theme.spacing.sm};
  flex-wrap: wrap;
  align-items: center;
`;

const Title = styled.h2`
  margin: 0;

  color: ${({ theme }) => theme.colors.gray900};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  font-size: ${({ theme }) => theme.fontSize['2xl']};
`;

const GenerationBadge = styled.span`
  padding: ${({ theme }) => theme.spacing.xs} ${({ theme }) => theme.spacing.md};
  border-radius: ${({ theme }) => theme.borderRadius.full};

  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  font-size: ${({ theme }) => theme.fontSize.sm};
`;

const InfoGrid = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.lg};
  flex-direction: column;
`;

const InfoRow = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.lg};
  align-items: center;
`;

const InfoLabel = styled.span`
  min-width: 64px;

  color: ${({ theme }) => theme.colors.gray600};
  font-size: ${({ theme }) => theme.fontSize.sm};
`;

const InfoValue = styled.span`
  color: ${({ theme }) => theme.colors.gray900};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  font-size: ${({ theme }) => theme.fontSize.base};
`;
